<template>
  <div>
    <confirmacion-revisado
      :dataPartido="dataPartido"
      @ponerRevisado="ponerRevisado($event)"
      @error="error($event)"
      :tarjetasAplicadas="noAplicadasSancion"
    >
    </confirmacion-revisado>
    <new-sancion
      :dataPartido="dataPartido"
      :dataSancion="dataSancion"
      :listMotivos="listMotivosSanciones"
      :arrayPartidos="partidosSuspendidos"
      :setear="setear"
      :especialUnico="especialUnico"
      :isManualProp="isManualProp"
      @resetSetear="setear = false"
      @trueSetear="setear = true"
      @changeRange="changeRange($event)"
      @recargaMotivos="showMensaje($event)"
      @changeTipoSancion="dataSancion.tipo = $event"
      @onlyMotivo="showNewMotivoOnly"
      :categoriaSeleccionada="categoriaSeleccionada"
      @recargaEspeciales="
        getEspeciales($store.state.someVariables.torneoSeleccionado.id_torneo)
      "
      @changeManual="changeMan($event)"
    ></new-sancion>
    <add-motivo
      :motivoSelected="motivoData"
      :opciones="listOpciones"
      :accion="accionMotivo"
      @motivoAgregado="
        getMotivosReglamento(campeonatoSeleccionado.value)
        getMotivos(dataPartido.id_campeonato)
      "
    >
    </add-motivo>
    <multas-modal
      :listMultas="listMultas"
      :dataPartido="dataPartido"
      :categoriaSeleccionada="categoriaSeleccionada"
      :idEquipo="dataPartido.id_local"
      :listMotivos="listMotivos"
      @changeEquipo="changeTab($event)"
    >
    </multas-modal>
    <add-tarjeta-dictamen
      :listEquiposElegidos="listEquiposElegidos"
      :dataPartido="dataPartido"
      :accion="accion"
      @reset="getJugadoresConTarjetas($event)"
      :categoriaSeleccionada="categoriaSeleccionada"
    ></add-tarjeta-dictamen>
    <b-tabs pills>
      <b-tab title="Revisión" active>
        <div class="row">
          <b-col md="4">
            <b-card no-body class="p-1">
              <b-row style="text-align:center">
                <b-col md="4" v-if="totalRojasSinAplicar != 0"
                  ><b-avatar
                    id="pop_roja"
                    badge-variant="danger"
                    :badge="`${totalRojasSinAplicar}`"
                    badge-offset="-0.5em"
                    badge-top
                    style="padding:8px; background-color: #eceef1; cursor:pointer"
                    :src="require('@/assets/images/recursos/roja.png')"
                  />
                  <b-popover
                    ref="popover"
                    target="pop_roja"
                    triggers="hover"
                    :show.sync="popoverShow"
                    placement="auto"
                    container="my-container"
                  >
                    <template v-slot:title>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <span>T.Rojas sin aplicar sanción</span>
                      </div>
                    </template>
                    <div>
                      <div v-for="item in listTRojasSA" :key="item.id">
                        <item-sin-aplicar
                          :item="item"
                          label="T.R"
                        ></item-sin-aplicar>
                      </div>
                    </div>
                  </b-popover>
                </b-col>
                <b-col md="4" v-if="totalRojasDASinAplicar != 0"
                  ><b-avatar
                    id="pop_roja_da"
                    badge-variant="danger"
                    :badge="`${totalRojasDASinAplicar}`"
                    badge-top
                    badge-offset="-0.5em"
                    style="padding:8px; background-color: #eceef1; cursor:pointer"
                    :src="require('@/assets/images/recursos/dosamar.png')"/>
                  <b-popover
                    ref="popover"
                    target="pop_roja_da"
                    triggers="hover"
                    :show.sync="popoverShowDA"
                    placement="auto"
                    container="my-container"
                  >
                    <template v-slot:title>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <span>T.Rojas x 2A sin aplicar sanción</span>
                      </div>
                    </template>
                    <div>
                      <div v-for="item in listTRojasDASA" :key="item.id">
                        <item-sin-aplicar
                          :item="item"
                          label="T.R x 2A"
                        ></item-sin-aplicar>
                      </div>
                    </div> </b-popover
                ></b-col>
                <b-col md="4" v-if="totalAASinAplicar != 0"
                  ><b-avatar
                    id="pop_roja_aa"
                    badge-variant="danger"
                    :badge="`${totalAASinAplicar}`"
                    badge-top
                    badge-offset="-0.5em"
                    style="padding:8px; background-color: #eceef1; cursor:pointer"
                    :src="require('@/assets/images/recursos/amarilla.png')"/>
                  <b-popover
                    ref="popover"
                    target="pop_roja_aa"
                    triggers="hover"
                    :show.sync="popoverShowAA"
                    placement="auto"
                    container="my-container"
                  >
                    <template v-slot:title>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <span
                          >Acumulación de amarillas sin aplicar sanción</span
                        >
                      </div>
                    </template>
                    <div>
                      <div v-for="item in listTRojasAASA" :key="item.id">
                        <item-sin-aplicar
                          :item="item"
                          label="T.R x Acum. Amarillas"
                        ></item-sin-aplicar>
                      </div>
                    </div> </b-popover
                ></b-col>
                <b-col md="12">
                  <b-badge
                    v-if="listPartidosTodos.length != 0"
                    @click="mostrarTodos"
                    class="d-block"
                    href="#"
                    pill
                    variant="danger"
                    style="border-radius:4px"
                  >
                    <span v-if="showTodos">Ocultar</span>
                    <span v-else>Mostrar</span>
                    {{ listPartidosTodos.length }} partidos sin revisar</b-badge
                  >
                </b-col>
              </b-row>
              <b-row>
                <b-col md="9">
                  <b-form-group style="margin-top:10px">
                    <flat-pickr
                      v-if="!showTodos"
                      v-model="rangeDate"
                      class="form-control mt-1"
                      :config="{ mode: 'range' }"
                      placeholder="Rango de fechas"
                      @on-change="getPartidos"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3" class="d-flex">
                  <b-button
                    v-if="
                      USER().rol === ROLES.SUPER ||
                        USER().rol === ROLES.ADMIN ||
                        USER().rol === ROLES.SANCIONES
                    "
                    v-b-tooltip.hover.v-primary
                    title="Generar acta de sanciones, si desea generar de todas las categorias no seleccione ninguna categoria"
                    variant="flat-primary"
                    class="btn-icon"
                    @click="generarActa"
                  >
                    <feather-icon size="22" icon="PrinterIcon" />
                  </b-button>
                </b-col>
              </b-row>

              <v-select
                v-if="!showTodos"
                placeholder="Selecciona Categoria"
                @input="getPartidos"
                :options="listCategorias"
                v-model="categoriaSeleccionada"
                :clearable="false"
              />

              <b-overlay :show="overlayPartidos" rounded="sm">
                <b-badge
                  v-if="
                    categoriaSeleccionada != null &&
                      categoriaSeleccionada.tiene_reset_amarillas
                  "
                  style="height:15px;margin-right:20px;font-size:9px"
                  variant="warning"
                >
                  <span>Reset Amarillas Activo</span>
                </b-badge>
                <div style="height:50vh; overflow:scroll; margin-top:10px">
                  <item-sancion
                    v-for="item in listPartidos"
                    :key="item.id"
                    :partido="item"
                    @changePartido="getJugadoresConTarjetas($event)"
                  ></item-sancion>
                </div>
              </b-overlay>
            </b-card>
          </b-col>
          <b-col md="8">
            <b-card no-body class="p-1">
              <b-row v-if="!overlayRevisado" class="d-flex align-items-center">
                <b-col md="10">
                  <b-badge
                    v-if="dataPartido.voc_revisada == 's'"
                    variant="success"
                    class="mr-1"
                  >
                    Revisado
                  </b-badge>
                  <small
                    >Etapa {{ dataPartido.etapa }} - Fecha
                    {{ dataPartido.num_fecha }} |
                    {{ dataPartido.fecha_aux }}</small
                  >
                </b-col>
                <!-- <b-col md="6" v-if="showOpciones">
                  <small class="text-muted text-capitalize"
                    >{{ dataPartido.local }} vs {{ dataPartido.visita }}</small
                  >
                </b-col> -->

                <b-col md="2" class="d-flex justify-content-end">
                  <b-button
                    v-if="
                      showOpciones &&
                        (USER().rol === ROLES.SUPER ||
                          USER().rol === ROLES.ADMIN ||
                          USER().rol === ROLES.SANCIONES)
                    "
                    v-b-tooltip.hover.v-primary
                    title="Agregar Tarjeta"
                    variant="flat-primary"
                    class="btn-icon"
                    size="sm"
                    @click="showNewTarjeta('tarjeta')"
                  >
                    <feather-icon size="14" icon="PlusIcon" />
                  </b-button>
                  <template
                    v-if="
                      dataPartido.voc_revisada != 's' &&
                        showOpciones &&
                        (USER().rol === ROLES.SUPER ||
                          USER().rol === ROLES.ADMIN ||
                          USER().rol === ROLES.SANCIONES)
                    "
                  >
                    <b-button
                      v-b-tooltip.hover.v-primary
                      title="Marcar como revisado"
                      variant="flat-primary"
                      class="btn-icon"
                      size="sm"
                      @click="confirmarRevisado"
                    >
                      <feather-icon size="14" icon="CheckIcon" />
                    </b-button>
                  </template>
                  <!-- <b-button
                    v-if="showOpciones"
                    v-b-tooltip.hover.v-primary
                    title="Editar dictamen"
                    variant="flat-primary"
                    class="btn-icon"
                    size="sm"
                    @click="showNewTarjeta('dictamen')"
                  >
                    <feather-icon size="14" icon="FileTextIcon" />
                  </b-button> -->
                  <!-- <b-button
                    v-b-tooltip.hover.v-primary
                    title="Crear sancion especial: úsese en caso que el jugador no tenga tarjetas asociadas"
                    variant="flat-primary"
                    class="btn-icon"
                    size="sm"
                    @click="showNewSancionOnly"
                  >
                    <feather-icon size="14" icon="UserXIcon" />
                  </b-button> -->
                  <b-button
                    v-if="showOpciones"
                    v-b-tooltip.hover.v-primary
                    title="Multas"
                    variant="flat-primary"
                    class="btn-icon"
                    size="sm"
                    @click="mostrarMultas"
                  >
                    <feather-icon size="14" icon="DollarSignIcon" />
                  </b-button>
                </b-col>
              </b-row>
              <b-overlay
                v-if="overlayRevisado"
                :show="overlayRevisado"
                rounded="sm"
                style="height: 40px;"
              >
              </b-overlay>
              <b-row style="margin-top:10px">
                <b-col md="2">
                  Estado :
                </b-col>
                <b-col md="8">
                  <b-alert
                    v-if="
                      dataPartido.final != 'PJ' && dataPartido.final != 'NPN'
                    "
                    :show="true"
                    variant="success"
                  >
                    <span
                      v-if="
                        dataPartido.final == 'E' ||
                          dataPartido.final == 'GL' ||
                          dataPartido.final == 'GV'
                      "
                    >
                      FINALIZADO
                    </span>
                    <span
                      v-if="
                        dataPartido.final == 'GLNP' ||
                          dataPartido.final == 'GVNP'
                      "
                    >
                      FINALIZADO NO PRESENTACION
                    </span>
                    <!-- <span @click="openVocalia"
                          >Ver Vocalia</span
                        > -->
                  </b-alert>
                  <b-alert
                    v-else-if="
                      dataPartido.final != 'PJ' && dataPartido.final == 'NPN'
                    "
                    :show="true"
                    variant="success"
                  >
                    <span>
                      FINALIZADO (NINGUNO SE PRESENTA)
                    </span>
                    <!-- <span @click="openVocalia" class="ver-vocalia"
                      >Ver Vocalia</span
                    > -->
                  </b-alert>
                  <b-alert
                    v-else-if="dataPartido.final == 'PJ'"
                    :show="true"
                    variant="danger"
                  >
                    <span>
                      POR JUGAR
                    </span>
                  </b-alert>
                </b-col>
                <b-col md="2"
                  ><span
                    v-if="dataPartido.final != 'PJ' && showOpciones"
                    @click="openVocalia"
                    style="font-size:12px;text-decoration:underline; cursor:pointer"
                    >Ver Vocalia</span
                  ></b-col
                >
                <b-col md="12" v-if="showOpciones">
                  <div
                    style="background-color:goldenrod; text-align:center; padding:3px"
                  >
                    <small
                      style="font-size:14px; color:white !important; font-weight: bold"
                      class="text-muted text-capitalize"
                      >{{ dataPartido.local }} {{ dataPartido.goles_local }} vs
                      {{ dataPartido.visita }}
                      {{ dataPartido.goles_visita }}</small
                    >
                  </div>
                </b-col>
                <b-col md="12">
                  <b-card
                    style="box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important"
                  >
                    <b-overlay :show="showLoading" rounded="sm">
                      <b-table
                        ref="refInvoiceListTable"
                        :fields="tableColumns"
                        :items="listTarjetas"
                        primary-key="id_tarjeta"
                        show-empty
                        responsive
                        small
                        empty-text="No se encontraron datos"
                        class="position-relative"
                        style="max-height:60vh"
                      >
                        <!-- Column: Id -->
                        <template #cell(num_camiseta)="data">
                          <p class="font-weight-bold">
                            {{ data.item.num_camiseta }}
                          </p>
                        </template>

                        <!-- Column: Player -->
                        <template #cell(jugador)="data">
                          <b-media vertical-align="center">
                            <template #aside>
                              <b-avatar
                                size="32"
                                :src="data.item.foto_jug"
                                :text="avatarText(data.item.nombres)"
                              />
                            </template>
                            <span class="font-weight-bold d-block text-nowrap">
                              {{ data.item.nombre_completo }}
                            </span>
                          </b-media>
                        </template>
                        <template #cell(tarjeta)="data">
                          <div v-if="data.item.t_a == 1">
                            <img
                              :src="
                                require('@/assets/images/recursos/amarilla.png')
                              "
                              alt=""
                              width="20"
                            />
                          </div>
                          <div v-else-if="data.item.t_r == 1">
                            <img
                              :src="
                                require('@/assets/images/recursos/roja.png')
                              "
                              alt=""
                              width="20"
                            />
                          </div>
                          <div v-else-if="data.item.doble_a == 1">
                            <img
                              :src="
                                require('@/assets/images/recursos/dosamar.png')
                              "
                              alt=""
                              width="20"
                            />
                          </div>
                        </template>
                        <template #cell(orden)="data">
                          <div v-if="data.item.t_a == 1">
                            <div
                              :id="`pop_info_amarillas${data.item.id_tarjeta}`"
                              class="orden-tarjeta"
                            >
                              {{ data.item.orden }}
                            </div>
                            <b-popover
                              ref="popover"
                              :target="
                                `pop_info_amarillas${data.item.id_tarjeta}`
                              "
                              triggers="hover"
                              :show.sync="popoverShowIA[data.item.id_tarjeta]"
                              placement="auto"
                              container="my-container"
                            >
                              <template v-slot:title>
                                <div>
                                  <span>Detalle de Amarillas acumuladas</span>
                                </div>
                              </template>
                              <div style="max-height: 350px; overflow-y: auto;">
                                <div
                                  v-for="item in data.item.detalle_amarillas"
                                  :key="item.id"
                                >
                                  <item-detalle-amarilla
                                    :item="item"
                                  ></item-detalle-amarilla>
                                </div>
                              </div>
                            </b-popover>
                          </div>
                        </template>
                        <template #cell(san)="data">
                          <span
                            class="font-weight-bold d-block text-nowrap"
                            v-if="
                              data.item.t_a == '1' &&
                                data.item.orden < data.item.totAmaParSusp &&
                                data.item.aprobado == 'n'
                            "
                          >
                            -
                          </span>
                          <div style="text-align:center">
                            <img
                              v-if="
                                (data.item.t_r == 1 ||
                                  data.item.doble_a == '1' ||
                                  (data.item.t_a == '1' &&
                                    data.item.orden ==
                                      data.item.totAmaParSusp)) &&
                                  data.item.aprobado == 'n' &&
                                  (USER().rol === ROLES.SUPER ||
                                    USER().rol === ROLES.ADMIN ||
                                    USER().rol === ROLES.SANCIONES)
                              "
                              :src="
                                require('@/assets/images/recursos/roja.gif')
                              "
                              alt=""
                              width="25"
                              style="cursor:pointer"
                              @click="showNewSancion(data.item)"
                              disabled
                            />
                          </div>
                          <small
                            v-if="data.item.aprobado == 's'"
                            class="text-muted"
                            style="cursor:pointer; text-decoration:underline; color:rgb(86, 145, 86) !important"
                            @click="getDetalleSancion(data.item)"
                          >
                            Ver Sancion
                          </small>
                          <div
                            style="color:#9d9dfc; font-size:10px"
                            v-if="
                              data.item.id_auditoria !== undefined &&
                                data.item.id_auditoria !== null
                            "
                          >
                            Modificada
                          </div>
                        </template>
                        <!-- Column: Actions -->
                        <template
                          #cell(opc)="data"
                          v-if="
                            USER().rol === ROLES.SUPER ||
                              USER().rol === ROLES.ADMIN ||
                              USER().rol === ROLES.SANCIONES
                          "
                        >
                          <div
                            class="text-nowrap"
                            v-if="data.item.aprobado == 'n'"
                          >
                            <feather-icon
                              :id="`invoice-row-${data.item.id}-preview-icon`"
                              icon="Trash2Icon"
                              size="16"
                              class="mx-1"
                              style="cursor:pointer"
                              @click="mostrarConfirmacion(data.item)"
                            />
                          </div>
                        </template>
                      </b-table>
                    </b-overlay>
                  </b-card>
                </b-col>
              </b-row>

              <template v-if="showOpciones">
                <b-card
                  style="box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important"
                >
                  <b-row class="m-1">
                    <b-col
                      md="12"
                      style="background-color: #edeff1;color: black; text-align: center;padding: 5px;"
                    >
                      SANCIONES DEL PARTIDO
                    </b-col>
                    <b-col md="12">
                      <v-select
                        placeholder="Seleccionar Articulo (Opcional)"
                        :clearable="false"
                        :options="listMotivosTipoPartido"
                        taggable
                        v-model="dataPartido.motivoAux"
                        @input="changeMotivo"
                        class="mb-1 mt-1 select-size-sm"
                        :disabled="dataPartido.save !== 's' ? false : true"
                      />
                    </b-col>

                    <b-col md="12">
                      <b-form-textarea
                        id="textarea-default"
                        placeholder="Detalle del árticulo"
                        rows="2"
                        size="sm"
                        max-rows="3"
                        disabled
                        v-model="dataPartido.detalle"
                      />
                    </b-col>
                    <div>
                      <b-col md="12"
                        ><div
                          style="font-size:12px; color:black; margin-top: 10px;"
                        >
                          {{ dataPartido.motivoAux.dataReglamento.descripcion }}
                        </div></b-col
                      >
                      <b-col md="12">
                        <b-form-radio
                          v-for="opcion in listOpcionesBaja"
                          :key="opcion.id"
                          v-model="dataPartido.reset_opcion"
                          style="text-align:left !important; margin-top:5px"
                          name="accion-baja"
                          :value="opcion.id_reset_opcion"
                          :disabled="dataPartido.save !== 's' ? false : true"
                        >
                          <!-- <span>{{opcion.descripcion}}</span> -->
                          <span
                            v-if="opcion.sigla === 'GL' || opcion.sigla == 'GV'"
                            style="font-size:11px; "
                          >
                            Gana Club</span
                          >
                          <span v-else style="font-size:11px; ">
                            {{ opcion.auxiliar }}</span
                          >
                          <span v-if="opcion.sigla === 'GL'">
                            {{ dataPartido.local }}</span
                          >
                          <span v-if="opcion.sigla === 'GV'">
                            {{ dataPartido.visita }}</span
                          >
                          <span v-if="opcion.mostrar_marcador === 's'">
                            {{ dataPartido.goles_no_presentacion }} x 0</span
                          >
                        </b-form-radio>
                      </b-col>
                      <b-col v-if="listOpcionesBaja.length != 0" md="12">
                        <div class="atencion">
                          Atención: Para cualquiera de los casos se MANTENDRÁ
                          GOLES Y TARJETAS
                        </div>
                      </b-col>
                    </div>
                    <b-col md="12" class="mt-2">
                      <span
                        class="mt-1"
                        style="font-size:12px; font-weight: bold"
                        >El DICTÁMEN se mostrará a los usuarios de la siguiente
                        manera:</span
                      >
                    </b-col>
                    <b-col md="12">
                      <!-- {{ dataPartido.motivoAux.label }} -->
                      <span
                        v-if="
                          dataPartido.save !== 's' &&
                            dataPartido.motivoAux.value != null
                        "
                        class="mt-1"
                        style="font-size:12px"
                        >{{ dataPartido.motivoAux.label }}:
                        {{ dataPartido.detalle }}</span
                      >
                    </b-col>

                    <b-col md="12">
                      <b-form-textarea
                        id="textarea-default"
                        placeholder="Complementar Dictamen"
                        rows="2"
                        size="sm"
                        max-rows="3"
                        v-model="dataPartido.dictamen"
                        :disabled="dataPartido.save !== 's' ? false : true"
                      />
                    </b-col>

                    <b-col
                      v-if="
                        USER().rol === ROLES.SUPER ||
                          USER().rol === ROLES.ADMIN ||
                          USER().rol === ROLES.SANCIONES
                      "
                      md="12"
                      class="mt-3"
                    >
                      <b-button
                        v-if="!showLoadingAplicar"
                        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                        :variant="
                          dataPartido.save != 's' ? 'primary' : 'danger'
                        "
                        size="sm"
                        @click="aplicaroRevertir"
                      >
                        <span
                          v-if="dataPartido.save !== 's'"
                          class="align-middle"
                          >Aplicar</span
                        >
                        <span v-else class="align-middle">Revertir</span>
                      </b-button>
                      <div v-if="showLoadingAplicar" class="text-center ">
                        <b-spinner variant="primary" label="Text Centered" />
                      </div>
                    </b-col>
                    <b-alert
                      :show="dismissCountDown"
                      v-height-fade.appear
                      :variant="variante"
                      class="mt-2"
                      style="position:absolute; bottom:55px;  width:92%; margin-left:-4px"
                      @dismiss-count-down="countDownChanged"
                    >
                      <div
                        :class="{
                          'alert-body danger': variante == 'danger',
                          'alert-body success': variante == 'success',
                        }"
                      >
                        {{ messageError }}
                      </div>
                    </b-alert>
                  </b-row>
                </b-card>
              </template>
            </b-card>
          </b-col>
        </div>
      </b-tab>
      <b-tab
        title="Especiales"
        @click="
          getEspeciales($store.state.someVariables.torneoSeleccionado.id_torneo)
        "
      >
        <especiales-sanciones
          :listSancionados="listSancionadosEpeciales"
          :showLoading="showLoadingEspeciales"
          @getDetalleEspecial="getDetalleEspecial($event)"
          @onlyEspecial="showNewSancionOnly"
          @recargaEspeciales="
            getEspeciales(
              $store.state.someVariables.torneoSeleccionado.id_torneo,
            )
          "
        ></especiales-sanciones>
      </b-tab>

      <b-tab
        title="Por Actualizar"
        @click="
          getPendientes($store.state.someVariables.torneoSeleccionado.id_torneo)
        "
      >
        <pendientes
          :listSancionados="listSancionadosPendientes"
          :showLoading="showLoadingPendientes"
          @delete="
            getPendientes(
              $store.state.someVariables.torneoSeleccionado.id_torneo,
            )
          "
        ></pendientes>
      </b-tab>
      <b-tab
        title="Reglamento y otros"
        @click="getMotivosReglamento(campeonatoSeleccionado.value)"
      >
        <seccion-reglamento
          :listMotivos="listMotivosReglamento"
          :showLoading="showLoadingReglamento"
          :listCampeonatos="listCampeonatos"
          :seleccionado="campeonatoSeleccionado"
          @onlyMotivo="showNewMotivoOnly"
          @onlyDetalle="showNewMotivoDetalle($event)"
          @recargaMotivos="
            getMotivosReglamento(campeonatoSeleccionado.value)
            getMotivos(dataPartido.id_campeonato)
            showMensajeDeleteMotivo()
          "
          @showError="showMensajeDeleteMotivoError()"
          @change="setearVar"
          @recargarReglamento="ordenaMotivos($event)"
        ></seccion-reglamento>
      </b-tab>
    </b-tabs>

    <b-modal
      id="modal-multi-3"
      size="sm"
      title="Confirmación"
      ok-only
      ok-title="Accept"
      v-model="showConfirmacion"
    >
      <b-card-text class="my-1">
        ¿ Deseas realmente eliminar la tarjeta ?
      </b-card-text>
      <template #modal-footer>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-primary"
          class="float-right mr-1"
          @click="showConfirmacion = false"
        >
          Cancelar
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right"
          @click="deleteTarjeta"
        >
          Aceptar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'

import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BAvatar,
  BOverlay,
  BTable,
  BMedia,
  BButton,
  VBTooltip,
  BModal,
  BCardText,
  BBadge,
  BTabs,
  BTab,
  BFormRadio,
  BSpinner,
  BFormTextarea,
  BAlert,
  VBPopover,
  BPopover,
  // BIcon,
  //   xxx
  // xxx
} from 'bootstrap-vue'
import {
  onMounted,
  ref,
  computed,
  watch,
  reactive,
  //  xxx,
} from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { heightFade } from '@core/directives/animations'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  ROLES,
  URL_PDF,
  URL_CARNET,
  // xxxxx,
  //  ssss,
} from '../../utils/variables'
import itemSancion from './itemSancion.vue'
import NewSancion from './NewSancion.vue'
import AddTarjetaDictamen from './AddTarjetaDictamen.vue'
import MultasModal from './MultasModal.vue'
import ConfirmacionRevisado from './ModalConfirmacion.vue'
import EspecialesSanciones from './EspecialesSanciones.vue'
import SeccionReglamento from './SeccionReglamento.vue'
import AddMotivo from './AddMotivo.vue'
import itemSinAplicar from './itemSInAplicar.vue'
import itemDetalleAmarilla from './itemDetalleAmarilla.vue'
import Pendientes from './Pendientes.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    flatPickr,
    itemSancion,
    vSelect,
    BAvatar,
    BOverlay,
    BTable,
    BMedia,
    NewSancion,
    BButton,
    AddTarjetaDictamen,
    BModal,
    BCardText,
    BBadge,
    MultasModal,
    ConfirmacionRevisado,
    BTabs,
    BTab,
    EspecialesSanciones,
    SeccionReglamento,
    AddMotivo,
    BFormRadio,
    BSpinner,
    BFormTextarea,
    BAlert,
    BPopover,
    itemSinAplicar,
    Pendientes,
    itemDetalleAmarilla,
    // BIcon,
  },
  directives: {
    'b-popover': VBPopover,
    'b-tooltip': VBTooltip,
    Ripple,
    heightFade,
  },
  setup() {
    const rangeDate = ref(null)
    const listPartidos = ref([])
    const listPartidosTodos = ref([])
    const listTRojasSA = ref([])
    const listTRojasDASA = ref([])
    const listTRojasAASA = ref([])
    const showTodos = ref(false)
    const popoverShow = ref(false)
    const popoverShowDA = ref(false)
    const popoverShowAA = ref(false)
    const popoverShowIA = ref([])
    // const totalSinRevisar=ref(0)
    const listCategorias = ref([])
    const accion = ref('')
    const partidosSuspendidos = ref([])
    const listCampeonatos = ref([])
    const listTarjetas = ref([])
    const listMotivos = ref([])
    const listMotivosSanciones = ref([])
    const listMotivosTipoPartido = ref([])
    const listOpciones = ref([])
    const listMotivosReglamento = ref([])
    const listMultas = ref([])
    const dataPartido = ref({})
    const dataSancion = ref({})
    const categoriaSeleccionada = ref({
      label: 'Selecciona Categoria',
      value: null,
      tiene_reset_amarillas: false,
    })
    const { getApi, postApi } = apiCall()
    const setear = ref(false)
    const showLoading = ref(false)
    const showLoadingAplicar = ref(false)
    const showLoadingEspeciales = ref(false)
    const showLoadingPendientes = ref(false)
    const showLoadingReglamento = ref(false)
    const listEquiposElegidos = ref([])
    const listOpcionesBaja = ref([])
    const listSancionadosEpeciales = ref([])
    const listSancionadosPendientes = ref([])
    const showConfirmacion = ref(false)
    const overlayPartidos = ref(false)
    const overlayRevisado = ref(false)
    const showOpciones = ref(false)
    const tarjetaElegida = ref(null)
    const especialUnico = ref(false)
    const detalleReglamento = ref('')
    const accionBaja = ref('')
    const conceptoVal = ref({ value: null, label: 'Seleccionar artículo' })
    const isOnlyDictamen = ref(false)
    const dismissCountDown = ref(0)
    const variante = ref('danger')
    const dismissSecs = ref(3)
    const messageError = ref(null)
    const isManualProp = ref(false)
    const accionMotivo = ref('i')
    const noAplicadasSancion = ref(null)

    const campeonatoSeleccionado = ref({
      label: 'Seleccione campeonato',
      value: null,
    })

    const tableColumns = [
      {
        key: 'num_camiseta',
        label: '#',
        stickyColumn: true,
        sortable: true,
      },
      { key: 'jugador', sortable: true },
      { key: 'equipo', sortable: true },
      { key: 'tarjeta', label: 'T', sortable: true },
      { key: 'orden', label: 'T.A', sortable: true },
      { key: 'san', label: 'sancion', sortable: true },
      { key: 'opc' },
    ]
    const motivoData = reactive({
      motivo: '',
      valor: '',
      detalle: null,
      detalle_acta: null,
      total_partidos: null,
      id_opcion_baja: null,
      tipo_partido_boolean: false,
      id_campeonato: false,
    })
    function changeMan(valor) {
      isManualProp.value = valor
    }

    function openVocalia() {
      window.open(
        `${URL_PDF}pdfVocalia/vocalia${
          dataPartido.value.id_partido
        }.pdf?v=${Math.random() * 100}`,
        // eslint-disable-next-line
        '_blank',
      )
    }
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function showMessageAlert(type, mensaje) {
      variante.value = type
      // hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }

    async function getOpcionesBaja(idOpcionBaja, estadoFinal) {
      // console.log(idOpcionBaja)
      listOpcionesBaja.value = []
      showLoadingReglamento.value = true
      const path = `ApiSanciones/getOpcionesBajaReset/${idOpcionBaja}/${estadoFinal}`
      const data = await getApi(URL, path)
      listOpcionesBaja.value = data.opciones
    }
    function changeMotivo(item) {
      // console.log(item)
      // console.log(dataPartido.value)
      if (item.dataReglamento.id_opcion_baja === null) {
        isOnlyDictamen.value = true
      } else {
        isOnlyDictamen.value = false
      }
      // dataPartido.value.motivo = item
      if (item.value === undefined) {
        dataPartido.value.detalle = ''
      } else if (item.value !== undefined) {
        dataPartido.value.detalle = `${
          item.dataReglamento.detalle == null ? '' : item.dataReglamento.detalle
        } `

        getOpcionesBaja(
          item.dataReglamento.id_opcion_baja,
          // eslint-disable-next-line
          dataPartido.value.final,
        )
        // console.log(item.value)
        if (item.value === undefined) {
          item.value = null
        }
      }
    }
    function showMensajeDeleteMotivo() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'ELIMINADO exitosamente',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'bottom-center',
          // eslint-disable-next-line
        },
      )
    }
    function showMensajeDeleteMotivoError() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title:
              'ERROR el reglamento a sido aplicado a una o varias sanciones acción no permitida',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            solid: true,
          },
        },
        {
          position: 'bottom-center',
          // eslint-disable-next-line
        },
      )
    }
    async function getEspeciales(idTorneo) {
      // console.log('obteniendo')
      listSancionadosEpeciales.value = []
      showLoadingEspeciales.value = true
      const path = `ApiSanciones/getSancionesEspeciales/${idTorneo}`
      const data = await getApi(URL, path)
      listSancionadosEpeciales.value = data.data
      showLoadingEspeciales.value = false
    }
    async function getPendientes(idTorneo) {
      // console.log('obteniendo')
      listSancionadosPendientes.value = []
      showLoadingPendientes.value = true
      const path = `ApiSanciones/getSancionesPendientes/${idTorneo}/0`
      const data = await getApi(URL, path)
      listSancionadosPendientes.value = data.data
      showLoadingPendientes.value = false
    }
    function transformCampeonatos(array, salida) {
      array.forEach(element => {
        const obj = {
          label: `${element.anio_inic} - ${element.anio_fin}`,
          value: element.id_campeonato,
          id_torneo: element.id_torneo,
          activo: element.activo,
        }
        salida.value.push(obj)
      })
    }
    async function getMotivosReglamento(idCampeonato) {
      listSancionadosEpeciales.value = []
      showLoadingReglamento.value = true
      const path = `ApiSanciones/getMotivosReglamento/${idCampeonato}`
      const data = await getApi(URL, path)
      listMotivosReglamento.value = data.motivos
      listOpciones.value = data.opciones
      showLoadingReglamento.value = false
    }
    function setearVar(item) {
      campeonatoSeleccionado.value = item
      getMotivosReglamento(campeonatoSeleccionado.value.value)
    }
    function ordenaMotivos() {
      // listMotivosReglamento.value = lista
      getMotivosReglamento(campeonatoSeleccionado.value.value)
    }
    function transformListMotivos(array) {
      const arraySalida = []
      array.forEach(element => {
        const obj = {
          label: `${element.motivo}`,
          value: element.id_motivo_sancion,
          dataReglamento: element,
        }
        arraySalida.push(obj)
      })
      return arraySalida
    }
    function filterMotivosTipoPartido(arrayEntrada) {
      return arrayEntrada.filter(
        // eslint-disable-next-line
        element =>
          // eslint-disable-next-line
          element.tipo_partido_boolean,
      )
    }
    function filterMotivosNormales(arrayEntrada) {
      return arrayEntrada.filter(
        // eslint-disable-next-line
        element =>
          // eslint-disable-next-line
          !element.tipo_partido_boolean,
      )
    }

    async function getMotivos(idCampeonato) {
      const path = `ApiSanciones/getMotivos/${idCampeonato}`
      const data = await getApi(URL, path)
      const auxMotivos = data.motivos
      const auxMotivosPartido = data.motivosPartido
      let listMotivosTipoPartidoAux = []
      let listMotivosAux = []

      listMotivosTipoPartidoAux = filterMotivosTipoPartido(auxMotivosPartido)
      listMotivosAux = filterMotivosNormales(auxMotivos)
      listMotivosTipoPartido.value = transformListMotivos(
        // eslint-disable-next-line
        listMotivosTipoPartidoAux,
      )
      listMotivosSanciones.value = transformListMotivos(listMotivosAux)
      listMotivos.value = transformListMotivos(auxMotivos)
      // console.log(listMotivosTipoPartido.value)

      listOpciones.value = data.opciones
    }
    function quitarDeSinSancionar(valor, array) {
      array.forEach((element, index) => {
        if (element.id_tarjeta === valor) {
          array.splice(index, 1)
        }
      })
    }
    function quitarDeSinRevisar(valor, array) {
      array.forEach((element, index) => {
        if (element.id_partido === valor) {
          array.splice(index, 1)
        }
      })
    }
    function showMensaje(valor) {
      getMotivos(dataPartido.value.id_campeonato)
      quitarDeSinSancionar(valor, listTRojasSA.value)
      quitarDeSinSancionar(valor, listTRojasDASA.value)
      quitarDeSinSancionar(valor, listTRojasAASA.value)
      store.commit(
        'someVariables/UPDATE_ACTIVATE_SANCION_PENDIENTE',
        // eslint-disable-next-line
        true,
      )
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'SANCIOON APLICADA exitosamente',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        },
      )
    }

    async function getMultas(idEquipo) {
      listMultas.value = []
      const path = `ApiMultas/getMultas/${idEquipo}/${dataPartido.value.id_partido}`
      const data = await getApi(URL, path)
      listMultas.value = data.data
      // console.log(data)
    }
    function changeTab(tipo) {
      if (tipo === 'local') {
        // console.log('local')
        getMultas(dataPartido.value.id_local)
      } else {
        // console.log('visita')
        getMultas(dataPartido.value.id_visita)
      }
    }

    async function getListCategoriasAdmin(idTorneo) {
      listCategorias.value = []
      const path = `ApiConfiguration/getCategoriasEquipos/${idTorneo}`
      const data = await getApi(URL, path)
      if (data.flag === 's') {
        data.data.forEach(element => {
          const obj = {
            label: `${element.disciplina} ${element.categoria}`,
            value: element.id_categoria,
            id_disciplina: element.id_disciplina,
            tiene_reset_amarillas: element.tiene_reset_amarillas,
          }
          listCategorias.value.push(obj)
        })
      } else {
        listCategorias.value = []
      }
    }
    function sumarSinSancionar(listaTarjetas) {
      let total = 0
      if (listaTarjetas.value.length !== 0) {
        listaTarjetas.value.forEach(element => {
          total += parseInt(element.total, 10)
        })
      }
      return total
    }
    const totalRojasSinAplicar = computed(() => sumarSinSancionar(listTRojasSA))
    const totalRojasDASinAplicar = computed(
      () =>
        // eslint-disable-next-line
        sumarSinSancionar(listTRojasDASA),
      // eslint-disable-next-line
    )
    const totalAASinAplicar = computed(() => sumarSinSancionar(listTRojasAASA))

    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado'],
    )
    watch(cambioTorneo, data => {
      // console.log('watch config')
      rangeDate.value = null
      categoriaSeleccionada.value = null
      listPartidos.value = []
      listTarjetas.value = []
      getListCategoriasAdmin(data.id_torneo)
    })
    function changeRange(item) {
      // console.log(item)
      dataSancion.value.duracionEspecial = item
    }
    // function countAmarillasEquipo(idEquipo) {
    //   return listTarjetas.value.filter(
    //     // eslint-disable-next-line
    //     element => idEquipo === element.id_equipo && element.t_a === '1'
    //   ).length
    // }
    // function countRojasEquipo(idEquipo) {
    //   return listTarjetas.value.filter(
    //     // eslint-disable-next-line
    //     element =>
    //       // eslint-disable-next-line
    //       idEquipo === element.id_equipo &&
    //       // eslint-disable-next-line
    //       (element.t_r === '1' || element.doble_a === '1')
    //   ).length
    // }
    // async function insertMultasTarjetasAutomatico() {
    //   // console.log(listTarjetas)
    //   const totalAmarillasLocal = countAmarillasEquipo(
    //     // eslint-disable-next-line
    //     dataPartido.value.id_local
    //   )
    //   const totalRojasLocal = countRojasEquipo(
    //     // eslint-disable-next-line
    //     dataPartido.value.id_local
    //   )
    //   const totalAmarillasVisita = countAmarillasEquipo(
    //     // eslint-disable-next-line
    //     dataPartido.value.id_visita
    //   )
    //   const totalRojasVisita = countRojasEquipo(
    //     // eslint-disable-next-line
    //     dataPartido.value.id_visita
    //   )
    //   const data = {
    //     id_categoria: categoriaSeleccionada.value.value,
    //     idLocal: dataPartido.value.id_local,
    //     idVisita: dataPartido.value.id_visita,
    //     idPartido: dataPartido.value.id_partido,
    //     total_amarillas_local: totalAmarillasLocal,
    //     total_amarillas_visita: totalAmarillasVisita,
    //     total_rojas_local: totalRojasLocal,
    //     total_rojas_visita: totalRojasVisita,
    //   }
    //   const path = 'ApiMultas/insertMultasTarjetas'
    //   await postApi(URL, path, data)
    //   // console.log(response)
    // }

    async function revertirSancion() {
      const path = 'ApiFixture/revertirpuntajes'
      const data = {
        id_partido: dataPartido.value.id_partido,
      }
      showLoadingAplicar.value = true
      const response = await postApi(URL, path, data)
      // console.log(response)
      if (response.flag === 'si') {
        dataPartido.value.save = 'n'
        dataPartido.value.motivoAux = {
          label: 'Seleccione un artículo (Opcional)',
          value: null,
          dataReglamento: { descripcion: null },
        }
        dataPartido.value.detalle = null
        listOpcionesBaja.value = []
        dataPartido.value.reset_opcion = null
        dataPartido.value.dictamen = null
        showLoadingAplicar.value = false
        showMessageAlert('success', 'Revertido exitosamente')
      }
      // if (response.flag === 'si') {
      //   getJugadoresConTarjetas(dataPartido.value)
      // }
    }

    async function revertirOnlyDictamen() {
      const path = 'ApiFixture/resetDictamen'
      const data = {
        id_partido: dataPartido.value.id_partido,
      }
      showLoadingAplicar.value = true
      const response = await postApi(URL, path, data)
      // console.log(response)
      if (response.flag === 'si') {
        dataPartido.value.save = 'n'
        dataPartido.value.motivoAux = {
          label: 'Seleccione un artículo (Opcional)',
          value: null,
          dataReglamento: { descripcion: null },
        }
        dataPartido.value.detalle = null
        listOpcionesBaja.value = []
        dataPartido.value.reset_opcion = null
        dataPartido.value.dictamen = null
        showLoadingAplicar.value = false
        showMessageAlert('success', 'Revertido exitosamente')
      }
      // if (response.flag === 'si') {
      //   getJugadoresConTarjetas(dataPartido.value)
      // }
    }
    async function resetOnlyDictamen() {
      if (dataPartido.value.motivoAux === null) {
        showMessageAlert('danger', 'Debes seleccionar una artículo')
      } else {
        showLoadingAplicar.value = true
        // continuar.value = true
        let dictameEnviar = ''
        if (dataPartido.value.motivoAux.value !== null) {
          dictameEnviar = dataPartido.value.motivoAux.label
        }
        // console.log(dictameEnviar)
        const data = {
          id_partido: dataPartido.value.id_partido,
          rol: USER().rol,
          tipoDato: 'sancion',
          idMotivo: dataPartido.value.motivoAux.value,
          dictamen: `${dictameEnviar} ${dataPartido.value.detalle ||
            ''} ${dataPartido.value.dictamen || ''}`,
          dataMovimiento: `Aplica dictamen ${dataPartido.value.categoria}  etapa:${dataPartido.value.etapa} grupo:${dataPartido.value.grupo} fecha #:${dataPartido.value.num_fecha} partido: ${dataPartido.value.local} vs ${dataPartido.value.visita} subido por el usuario
          ${dataPartido.value.user_modifica}`,
          idTorneo:
            store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
          id_user_modifica: USER().id_usuario,
        }
        const path = 'ApiFixture/updateDictamen'
        const response = await postApi(URL, path, data)
        // console.log(response)
        if (response.flag === 'si') {
          dataPartido.value.save = 's'
          dataPartido.value.dictamen = data.dictamen
          resetOnlyDictamen.value = true
          dataPartido.value.motivoAux.value = null
          showMessageAlert('success', 'Dictamen aplicado exitosamente')
        } else {
          // showMessageAlert('danger', 'Ha ocurrido un error vuelve a intentarlo')
          // console.log('vuelve a intentarl')
        }
        // showConfirmacion.value = false
        showLoadingAplicar.value = false
      }
    }
    async function getPartidosSinRevisar(idTorneo) {
      // console.log(dataFecha)
      // console.log(categoriaSeleccionada.value)

      // overlayPartidos.value = true
      listPartidosTodos.value = []
      const path = `ApiFixture/getPartidosSinRevisar/${idTorneo}`
      const data = await getApi(URL, path)
      listPartidosTodos.value = data.data
      listTRojasSA.value = data.trSA
      listTRojasAASA.value = data.taaSA
      listTRojasDASA.value = data.trdaSA
      // overlayPartidos.value = false
    }
    // function buscarEnArray(array, idPartido) {
    //   console.log(idPartido)
    //   return array.findIndex(element => element.id_partido === idPartido)
    // }
    function separaFecha() {
      // console.log(rangeDate.value)
      let auxiliar = null
      if (rangeDate.value != null) {
        const arrayFechas = rangeDate.value.split('to')
        if (arrayFechas.length >= 2) {
          auxiliar = {
            valido: true,
            inicio: arrayFechas[0].trim(),
            fin: arrayFechas[1].trim(),
          }
        } else {
          auxiliar = {
            valido: false,
            inicio: null,
            fin: null,
          }
        }
      }

      return auxiliar
    }

    async function getPartidos() {
      const dataFecha = separaFecha()
      // console.log(dataFecha)
      // console.log(categoriaSeleccionada.value)
      listTarjetas.value = []
      showOpciones.value = false
      dataPartido.value = {}
      if (dataFecha != null && categoriaSeleccionada.value !== null) {
        if (dataFecha.valido) {
          overlayPartidos.value = true
          listPartidos.value = []
          const path = `ApiFixture/getPartidosRangoFecha/${dataFecha.inicio}/${dataFecha.fin}/${categoriaSeleccionada.value.value}`
          const data = await getApi(URL, path)
          listPartidos.value = data.data
          overlayPartidos.value = false
        }
      }
    }
    function putEquiposSelectNewTarjeta(item) {
      const listReturn = [
        { label: item.local, value: item.id_local },
        { label: item.visita, value: item.id_visita },
      ]
      return listReturn
    }
    async function getJugadoresConTarjetas(partido) {
      // console.log(partido)
      // const verify = Object.e/ntries(partido).length
      // console.log(verify)
      dataPartido.value = partido
      getMotivos(dataPartido.value.id_campeonato)
      // console.log(dataPartido.value)
      showLoading.value = true
      listTarjetas.value = []
      showOpciones.value = true

      if (dataPartido.value.reset_opcion === null) {
        if (dataPartido.value.motivo !== null) {
          dataPartido.value.motivoAux = {
            label: `${dataPartido.value.motivo}`,
            value: null,
            dataReglamento: { descripcion: dataPartido.value.descripcion },
          }
        } else {
          listOpcionesBaja.value = []
          dataPartido.value.motivoAux = {
            label: 'Seleccione un artículo (Opcional)',
            value: null,
            dataReglamento: { descripcion: null },
          }
        }
      } else if (
        dataPartido.value.reset_opcion !== null &&
        dataPartido.value.reset_opcion !== '0'
      ) {
        getOpcionesBaja(dataPartido.value.id_opcion_baja)
        dataPartido.value.motivoAux = {
          label: `${dataPartido.value.motivo}`,
          value: dataPartido.value.id_opcion_baja,
          dataReglamento: { descripcion: dataPartido.value.descripcion },
        }
      } else {
        // listOpcionesBaja.value = []
        // dataPartido.value.motivoAux = {
        //   label: 'Seleccione un artículo (Opcional)',
        //   value: null,
        //   dataReglamento: { descripcion: null },
        // }
      }
      if (dataPartido.value.motivo !== null) {
        // dataPartido.value.motivoAux = {
        //   label: `${dataPartido.value.motivo}`,
        //   value: null,
        //   dataReglamento: { descripcion: dataPartido.value.descripcion },
        // }
      }

      const path = `ApiSanciones/getTarjetasIdPartido/${partido.id_partido}`
      const data = await getApi(URL, path)
      // console.log(data)
      listTarjetas.value = data.data
      listEquiposElegidos.value = putEquiposSelectNewTarjeta(partido)
      showLoading.value = false
    }
    async function resetPartido() {
      // console.log(dataPartido.value.motivoAux)
      // console.log(dataPartido.value.reset_opcion)
      if (dataPartido.value.motivoAux === null) {
        showMessageAlert('danger', 'Debes seleccionar una artículo')
      } else if (
        dataPartido.value.reset_opcion === '0' ||
        dataPartido.value.reset_opcion === 0 ||
        dataPartido.value.reset_opcion === '' ||
        dataPartido.value.reset_opcion === undefined ||
        dataPartido.value.reset_opcion === null
      ) {
        showMessageAlert('danger', 'Debes seleccionar una opcion')
      } else {
        showLoadingAplicar.value = true
        // continuar.value = true
        // console.log(dataPartido)
        const data = {
          id_partido: dataPartido.value.id_partido,
          name_important: dataPartido.value.name_important,
          rol: USER().rol,
          quitarGolesNoSePresentan:
            dataPartido.value.quitar_goles_no_se_presentan,
          golesNoPresentacion: dataPartido.value.goles_no_presentacion,
          accion: dataPartido.value.reset_opcion,
          tipoDato: 'sancion',
          idMotivo: dataPartido.value.motivoAux.value,
          dictamen: `${dataPartido.value.motivoAux.label} ${dataPartido.value
            .detalle || ''} ${dataPartido.value.dictamen || ''}`,
          dataMovimiento: `Aplica sancion ${dataPartido.value.categoria}  etapa:${dataPartido.value.etapa} grupo:${dataPartido.value.grupo} fecha #:${dataPartido.value.num_fecha} partido: ${dataPartido.value.local} vs ${dataPartido.value.visita} subido por el usuario
          ${dataPartido.value.user_modifica}, data_local [${dataPartido.value.pts_local}], data_visita [${dataPartido.value.pts_visita}], estado_ant ${dataPartido.value.final}, reset_opcion ${accionBaja.value}`,
          idTorneo:
            store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
          id_user_modifica: USER().id_usuario,
        }
        const path = 'ApiFixture/darBajaPartido'
        const response = await postApi(URL, path, data)
        // console.log(response)
        if (response.flag === 'si') {
          dataPartido.value.save = 's'
          dataPartido.value.dictamen = data.dictamen
          dataPartido.value.reset_opcion = data.accion
          dataPartido.value.motivo = dataPartido.value.motivoAux.label
          dataPartido.value.id_opcion_baja =
            listOpcionesBaja.value[0].id_opcion_baja
          // console.log(dataPartido.value.motivoAux)
          // const indexTodos = buscarEnArray(
          //   listPartidosTodos.value,
          //   // eslint-disable-next-line
          //   data.id_partido
          // )
          // console.log(indexTodos)
          // listPartidosTodos.value[indexTodos].motivo =
          //   dataPartido.value.motivoAux.label
          // listPartidosTodos.value[indexTodos].reset_opcion = data.accion
          // console.log(listPartidosTodos.value)
          // console.log(showTodos.value)
          // if (showTodos.value) {
          // console.log('uno')
          // getPartidosSinRevisar(
          //   // eslint-disable-next-line
          //   store.getters['someVariables/getTorneoSeleccionado'].id_torneo
          // )
          // getJugadoresConTarjetas(dataPartido.value)
          // } else {
          //   console.log('dos')
          //   getPartidos()
          // }

          // label: `${dataPartido.value.motivo}`,
          // value: dataPartido.value.id_opcion_baja,
          showMessageAlert('success', 'Sanción aplicada exitosamente')
        } else {
          // showMessageAlert('danger', 'Ha ocurrido un error vuelve a intentarlo')
          // console.log('vuelve a intentarl')
        }
        // showConfirmacion.value = false
        showLoadingAplicar.value = false
      }
    }
    function aplicaroRevertir() {
      // console.log(dataPartido.value.motivoAux)
      // console.log(dataPartido.value.save)
      if (dataPartido.value.motivoAux.value === null) {
        isOnlyDictamen.value = true
      }
      if (dataPartido.value.save === 's') {
        if (dataPartido.value.motivoAux.value === null) {
          // console.log('revertir solo dictmen')
          revertirOnlyDictamen()
        } else {
          revertirSancion()
        }
      } else if (dataPartido.value.save !== 's') {
        if (isOnlyDictamen.value) {
          // console.log('IS DICTAMEN')
          resetOnlyDictamen()
        } else if (!isOnlyDictamen.value) {
          resetPartido()
        }
      }
    }
    function confirmarRevisado() {
      store.commit(
        'someVariables/UPDATE_SHOW_CONFIRMA_PARTIDO_REVISADO',
        // eslint-disable-next-line
        true,
      )
      noAplicadasSancion.value = listTarjetas.value.filter(
        // eslint-disable-next-line
        element =>
          // eslint-disable-next-line
          element.aprobado === 'n' &&
          // eslint-disable-next-line
          (element.t_r === '1' || element.doble_a === '1'),
      ).length
      // if (noAplicadasSancion === 0) {
      //   store.commit(
      //     'someVariables/UPDATE_SHOW_CONFIRMA_PARTIDO_REVISADO',
      //     // eslint-disable-next-line
      //     true
      //   )
      // } else {
      //   this.$toast(
      //     {
      //       component: ToastificationContent,
      //       props: {
      //         title:
      //           'Existen sanciones sin aplicar, Porfavor aplica todas las sanciones para continuar  ',
      //         icon: 'AlertCircleIcon',
      //         variant: 'danger',
      //         solid: true,
      //       },
      //     },
      //     {
      //       position: 'bottom-center',
      //       // eslint-disable-next-line
      //     }
      //   )
      // }
      // console.log(listTarjetas.value)
    }
    function error(mensaje) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: `Error, ${mensaje}`,
            icon: 'AlertCircleIcon',
            variant: 'danger',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        },
      )
    }
    async function generarActa() {
      const dataFecha = separaFecha()
      if (dataFecha != null) {
        if (dataFecha.valido) {
          const dataSend = {
            fechaInicio: dataFecha.inicio,
            fechaFin: dataFecha.fin,
            idCategoria: categoriaSeleccionada?.value?.value || 0,
            user: `${USER().nombre} ${USER().apellido}`,
          }
          const path = 'ApiSanciones/escribirActaSancionPDF'
          await postApi(URL, path, dataSend)
          window.open(
            `${URL_CARNET}acta.pdf?v=${Math.random() * 100}`,
            // eslint-disable-next-line
            '_blank',
          )
        }
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Error, Debe seleccionar un rango de fechas',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          },
        )
      }
    }
    async function ponerRevisado(valor) {
      overlayRevisado.value = true
      dataPartido.value.voc_revisada = 's'
      quitarDeSinRevisar(valor, listPartidosTodos.value)
      if (listPartidosTodos.value.length === 0) {
        showTodos.value = false
      }
      // insertMultasTarjetasAutomatico()
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'PARTIDO REVISADO exitosamente',
            icon: 'CheckIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        },
      )
      // const path = 'ApiFixture/revisarPartido'
      // const data = {
      //   idPartido: dataPartido.value.id_partido,
      //   idLocal: dataPartido.value.id_local,
      //   idVisita: dataPartido.value.id_visita,
      // }
      // const response = await postApi(URL, path, data)
      // if (response.flag === 'si') {
      //   console.log('si')
      //   dataPartido.value.voc_revisada = 's'
      //   insertMultasTarjetasAutomatico()
      // } else {
      //   console.log('no')
      // }
      overlayRevisado.value = false
    }

    function mostrarMultas() {
      store.commit('someVariables/UPDATE_SHOW_MULTAS', true)
      getMultas(dataPartido.value.id_local)
      getMotivos(dataPartido.value.id_campeonato)
    }
    function showNewSancion(item) {
      especialUnico.value = false
      isManualProp.value = false
      getMotivos(dataPartido.value.id_campeonato)
      store.commit('someVariables/UPDATE_SHOW_NEW_SANCION', true)
      item.listPartidos = []
      // item.duracion = 0
      // item.motivo = {
      //   value: null,
      //   label: 'Seleccionar motivo',
      // }
      // if (item.tipo === undefined) item.tipo = 'n'
      // console.log(item)
      // item.tipo = 'n'
      dataSancion.value = item
      setear.value = false
    }
    function showNewSancionOnly() {
      especialUnico.value = true
      isManualProp.value = false
      getMotivos(campeonatoSeleccionado.value.value)
      store.commit('someVariables/UPDATE_SHOW_NEW_SANCION', true)
      const item = {
        tipo: 'e',
        nombres: null,
      }
      // item.listPartidos = []
      // // item.duracion = 0
      // // item.motivo = {
      // //   value: null,
      // //   label: 'Seleccionar motivo',
      // // }
      dataSancion.value = item
      // dataSancion.value.nombres = null
      // dataSancion.value.apellidos = null
      // dataSancion.value.ci_pasaporte = null
      // dataSancion.value.equipo = null
      // dataSancion.value.num_camiseta = null
      // setear.value = false
      // console.log(dataSancion.value)
    }
    function showNewMotivoOnly() {
      // especialUnico.value = true
      // getMotivos()
      motivoData.detalle = ''
      motivoData.detalle_acta = ''
      motivoData.valor = ''
      motivoData.motivo = ''
      motivoData.total_partidos = null
      motivoData.id_campeonato = campeonatoSeleccionado.value.value
      accionMotivo.value = 'i'
      motivoData.tipo_partido_boolean = false
      motivoData.id_motivo_sancion = null

      store.commit('someVariables/UPDATE_SHOW_NEW_MOTIVO', true)
      // const item = {
      //   tipo: 'e',
      //   nombres: null,
      // }
    }
    function showNewMotivoDetalle(item) {
      // especialUnico.value = true
      // getMotivos()
      accionMotivo.value = 'u'
      motivoData.detalle = item.detalle
      motivoData.detalle_acta = item.detalle_acta
      motivoData.valor = item.valor
      motivoData.motivo = item.motivo
      motivoData.total_partidos = item.total_partidos
      motivoData.tipo_partido_boolean = item.tipo_partido_boolean
      motivoData.id_opcion_baja = item.id_opcion_baja
      motivoData.id_campeonato = campeonatoSeleccionado.value.value
      motivoData.id_motivo_sancion = item.id_motivo_sancion

      store.commit('someVariables/UPDATE_SHOW_NEW_MOTIVO', true)
      // const item = {
      //   tipo: 'e',
      //   nombres: null,
      // }
    }
    function showNewTarjeta(action) {
      accion.value = action
      store.commit('someVariables/UPDATE_SHOW_TARJETA_DICTAMEN', true)
    }
    function mostrarConfirmacion(item) {
      showConfirmacion.value = true
      tarjetaElegida.value = item
      // console.log(tarjetaElegida.value)
    }

    function mostrarTodos() {
      listTarjetas.value = []
      showOpciones.value = false
      dataPartido.value = {}
      showTodos.value = !showTodos.value
      if (showTodos.value) {
        listPartidos.value = listPartidosTodos.value
        rangeDate.value = null
        categoriaSeleccionada.value = null
      } else {
        listPartidos.value = []
      }
    }

    async function getDetalleSancion(item) {
      especialUnico.value = false
      getMotivos(dataPartido.value.id_campeonato)
      const path = `ApiSanciones/getSancionIdTarjetaRel/${item.id_tarjeta}/${item.id_equipo}`
      const data = await getApi(URL, path)
      // console.log(data.data)
      // console.log(item)
      item.duracion = data.data.duracion
      // item.motivo = data.data.motS
      item.listPartidos = data.detalle
      item.tipo = data.data.tipo
      item.fecha_incio_sancion = data.data.fecha_incio_sancion
      item.fecha_fin_especial = data.data.fecha_fin_especial
      item.rangeSancion = `${data.data.fecha_incio_sancion} to ${data.data.fecha_fin_especial}`
      item.duracionEspecial = data.data.diferencia
      item.id_sancion = data.data.id_sancion
      item.inicio_auxiliar = data.data.inicio_auxiliar
      item.fin_auxiliar = data.data.fin_auxiliar
      item.motivo_auxiliar = data.data.motivo_auxiliar
      item.detalle = data.data.detalleArt
      item.userAplica = data.data.userAplica
      item.id_auditoria = data.data.id_auditoria
      item.fecha_mod = data.data.fecha_mod
      item.id_motivo_sancion_ant = data.data.id_motivo_sancion_ant
      item.duracion_ant = data.data.duracion_ant
      item.motivo_ant = data.data.motSAnt
      item.num_pendientes = Number(data.data.num_pendientes)
      item.num_pendientes_entrada = data.data.num_pendientes
      item.id_sancion_pendiente = data.data.id_sancion_pendiente
      if (item.aprobado === 's') {
        isManualProp.value = true
      } else {
        isManualProp.value = false
      }

      // item.motivo = data.data.motS
      item.motivo = {
        value: data.data.id_motivo_sancion,
        label: data.data.motS,
      }
      setear.value = true
      dataSancion.value = { ...item }
      // console.log(dataSancion.value)
      partidosSuspendidos.value = data.detalle
      // const action = store.getters['someVariables/getSancion']
      store.commit(
        'someVariables/UPDATE_SANCION',
        // eslint-disable-next-line
        item,
      )
      // console.log(partidosSuspendidos.value)
      // console.log(dataSancion.value)
      store.commit('someVariables/UPDATE_SHOW_NEW_SANCION', true)

      // item.

      // apellidos
      // nombres
      // equipo
      // num_camiseta
      // ci_pasaporte
    }
    function getDetalleEspecial(item) {
      especialUnico.value = true
      setear.value = true
      getMotivos(campeonatoSeleccionado.value.value)
      item.motivo = {
        value: item.id_motivo_sancion,
        label: item.concepto,
      }
      item.tipo = 'e'
      item.rangeSancion = `${item.fecha_sancion} to ${item.fecha_fin_especial}`
      item.duracionEspecial = item.diferencia
      item.aprobado = 's'
      dataSancion.value = item
      store.commit(
        'someVariables/UPDATE_SANCION',
        // eslint-disable-next-line
        item,
      )
    }

    function definirTarjetaBorrada(ta, tr, trda) {
      let tarjeta = ''
      if (ta === '1') {
        tarjeta = 'T.A'
      } else if (tr === '1') {
        tarjeta = 'T.R'
      } else if (trda === '1') {
        tarjeta = 'T.R.D.A'
      }
      return tarjeta
    }
    async function deleteTarjeta() {
      const path = 'ApiFixture/deleteTarjeta'
      const tarjetaBorrada = definirTarjetaBorrada(
        tarjetaElegida.value.t_a,
        tarjetaElegida.value.t_r,
        // eslint-disable-next-line
        tarjetaElegida.value.doble_a,
      )
      const data = {
        idTarjeta: tarjetaElegida.value.id_tarjeta,
        idUsuario: USER().id_usuario,
        idTorneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        dataMovimiento: `Elimina tarjeta (${tarjetaBorrada}) al jugador N: ${tarjetaElegida.value.num_camiseta} del club ${tarjetaElegida.value.equipo} ${dataPartido.value.categoria}
        partido del ${dataPartido.value.fecha} - ${dataPartido.value.local} vs ${dataPartido.value.visita} `,
      }
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        getJugadoresConTarjetas(dataPartido.value)
      }
      showConfirmacion.value = false
    }

    onMounted(() => {
      getListCategoriasAdmin(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      )
      getPartidosSinRevisar(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      )
      transformCampeonatos(
        store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
        // eslint-disable-next-line
        listCampeonatos,
      )
      const campActivo = listCampeonatos.value.find(
        // eslint-disable-next-line
        element => element.activo === 's',
      )
      campeonatoSeleccionado.value = campActivo
      // getMotivos()
      // console.log(refP.value)
    })
    return {
      rangeDate,
      getPartidos,
      listPartidos,
      listCategorias,
      categoriaSeleccionada,
      tableColumns,
      showLoading,
      showLoadingAplicar,
      getJugadoresConTarjetas,
      listTarjetas,
      avatarText,
      showNewSancion,
      dataPartido,
      dataSancion,
      listMotivos,
      listMotivosSanciones,
      getDetalleSancion,
      partidosSuspendidos,
      setear,
      showNewTarjeta,
      listEquiposElegidos,
      accion,
      mostrarConfirmacion,
      deleteTarjeta,
      showConfirmacion,
      overlayPartidos,
      overlayRevisado,
      ponerRevisado,
      showOpciones,
      changeRange,
      showNewSancionOnly,
      especialUnico,
      mostrarMultas,
      listMultas,
      changeTab,
      getMotivos,
      showMensaje,
      confirmarRevisado,
      getEspeciales,
      listSancionadosEpeciales,
      listSancionadosPendientes,
      showLoadingReglamento,
      showLoadingEspeciales,
      showLoadingPendientes,
      getDetalleEspecial,
      USER,
      ROLES,
      getMotivosReglamento,
      listMotivosReglamento,
      showNewMotivoOnly,
      motivoData,
      showMensajeDeleteMotivo,
      showMensajeDeleteMotivoError,
      accionBaja,
      conceptoVal,
      detalleReglamento,
      changeMotivo,
      resetPartido,
      openVocalia,
      listOpciones,
      listOpcionesBaja,
      listMotivosTipoPartido,
      aplicaroRevertir,
      countDownChanged,
      dismissCountDown,
      dismissSecs,
      resetOnlyDictamen,
      messageError,
      variante,
      listPartidosTodos,
      mostrarTodos,
      showTodos,
      popoverShow,
      popoverShowDA,
      popoverShowAA,
      popoverShowIA,
      listTRojasSA,
      listTRojasDASA,
      listTRojasAASA,
      totalRojasSinAplicar,
      totalRojasDASinAplicar,
      totalAASinAplicar,
      getPendientes,
      itemDetalleAmarilla,
      isManualProp,
      changeMan,
      listCampeonatos,
      campeonatoSeleccionado,
      setearVar,
      showNewMotivoDetalle,
      accionMotivo,
      error,
      noAplicadasSancion,
      ordenaMotivos,
      generarActa,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
.box-sin-aplicar {
  background-color: rgb(223, 221, 221);
  width: auto;
  height: 80px;
  margin: 10px;
  padding: 4px;
  border-radius: 4px;
}
.orden-tarjeta {
  background-color: #f3f1b7;
  padding: 0px 4px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
}
.atencion {
  font-weight: bold;
  font-size: 13px;
  background-color: red;
  color: white;
  border-radius: 4px;
  padding: 4px;
  margin-top: 5px;
}
</style>
